import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { Notify } from '@flexisaf/flexibull2';
import urls from 'utils/config';
import {
  batchProcessSuccessfulStageUpdate,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* batchProcess({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/candidates`;
  const { applicants, comment, status, locationId } = data;

  const formData = {
    candidateIds: applicants,
    stageId: status?.value,
  };
  if (comment) {
    formData.reason = comment;
  }
  if (locationId) {
    formData.locationId = locationId;
  }

  const response = yield request({
    method: 'patch',
    data: formData,
    url,
  });
  if (response.success) {
    if (cb && typeof cb === 'function') {
      cb();
    }
    Notify('Applicant(s) stage updated successfully', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield put(batchProcessSuccessfulStageUpdate());
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onBatchProcess() {
  yield takeEvery(
    ApplicantsActionTypes.BATCH_PROCESS_APPLICANT_STAGE,
    batchProcess
  );
}
